<div id="notices" class="pb-4">
    <div class="container">
        <div class="card shadow border-0 p-4 rounded-4">
            <div class="row">
                <div class="col-12">
                    <h2 class="home-title mb-2">Notices & Circulars</h2>

                    <owl-carousel-o [options]="customOptions">
                        <ng-container *ngFor="let item of notices">
                            <ng-template carouselSlide [id]="item.id">
                                <div class="card card1 border-0 shadow m-3 rounded-3">
                                    <div class="date">
                                        <span class="fw-bold">{{item.date}}</span> <br> {{item.month}} <br> {{item.year}}
                                    </div>
                                    <div class="content p-3 fw-semibold d-flex flex-column justify-content-between">
                                        <a *ngIf="item.pdfUrl || item.imageUrl" [href]="encodeURL(item.pdfUrl || item.imageUrl)" target="_blank" class="text-dark text-decoration-none">
                                            <span>{{item.name}}</span>
                                        </a>
                                        <span *ngIf="!item.pdfUrl && !item.imageUrl">{{item.name}}</span>
                                        <div class="mt-2 d-flex align-items-center flex-wrap" *ngIf="item.pdfUrl || item.imageUrl">
                                            <a *ngIf="item.pdfUrl" [href]="encodeURL(item.pdfUrl)" target="_blank" class="text-primary text-decoration-none small me-3">
                                                <i class="far fa-file-pdf me-1 text-danger"></i> View PDF
                                            </a>
                                            <a *ngIf="item.imageUrl" [href]="encodeURL(item.imageUrl)" target="_blank" class="text-primary text-decoration-none small">
                                                <i class="far fa-image me-1 text-success"></i> View Image
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                    </owl-carousel-o>
                    
                </div>
            </div>
        </div>
    </div>
</div>

<div id="events" class="pb-4">
    <div class="container">
        <div class="card shadow border-0 p-4 rounded-4">
            <div class="row">
                <div class="col-12">
                    <h2 class="home-title mb-2">Events @IIMT</h2>

                    <owl-carousel-o [options]="customOptions">
                        <ng-container *ngFor="let item of events">
                            <ng-template carouselSlide [id]="item.id">
                                <div class="card card1 border-0 shadow m-3 rounded-3">
                                    <div class="date">
                                        <span class="fw-bold">{{item.date}}</span> <br> {{item.month}} <br> {{item.year}}
                                    </div>
                                    <div class="content p-3 fw-semibold d-flex flex-column justify-content-between">
                                        <a *ngIf="item.pdfUrl || item.imageUrl" [href]="encodeURL(item.pdfUrl || item.imageUrl)" target="_blank" class="text-dark text-decoration-none">
                                            <span>{{item.name}}</span>
                                        </a>
                                        <span *ngIf="!item.pdfUrl && !item.imageUrl">{{item.name}}</span>
                                        <div class="mt-2 d-flex align-items-center flex-wrap" *ngIf="item.pdfUrl || item.imageUrl">
                                            <a *ngIf="item.pdfUrl" [href]="encodeURL(item.pdfUrl)" target="_blank" class="text-primary text-decoration-none small me-3">
                                                <i class="far fa-file-pdf me-1 text-danger"></i> View PDF
                                            </a>
                                            <a *ngIf="item.imageUrl" [href]="encodeURL(item.imageUrl)" target="_blank" class="text-primary text-decoration-none small">
                                                <i class="far fa-image me-1 text-success"></i> View Image
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                    </owl-carousel-o>
                    
                </div>
            </div>
        </div>
    </div>
</div>